export default __webpack_public_path__ + "static/media/selenium.97b80559.svg";